import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
// import { getCategoryOption } from "../../utils/ApiCalls/Mobile/ActivityMasters";
import { addlog } from "../../utils/ApiCalls/Logs";
import { getCategoryOption } from "../../utils/ApiCalls/Mobile/VenueMaster";
import {
  createSailingCurrency,
  updateSailingCurrency,
} from "../../utils/ApiCalls/SailingDates";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../utils/Validation/checkPermission";
import moment from "moment";
import { LOG_ACTIONS, LOG_TYPES } from "../../utils/Constant/LogConstant";

const ShipCurrencyInput = ({ venus }) => {
  const [currency, setCurrency] = useState("");
  const [vesselId, setVesselId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [vesselOptions, setVesselOptions] = useState([]);
  const [deckOptions, setDeckOptions] = useState([]);
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [currencyError, setCurrencyError] = useState("");
  const [vesselError, setVesselError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    if (venus) {
      setCurrency(venus?.currency);
      setIsActive(venus?.is_active);
      setVesselId(venus?.vessel_id);
      setStartDate(formatDateForInput(venus?.from_date));
      setEndDate(formatDateForInput(venus?.to_date));
    }
  }, [venus]);

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
    
    let dateString = dateStr.toString();
    
    if (dateString.includes('T')) {
      const [datePart, timePart] = dateString.split('T');
      const timeOnly = timePart.split('.')[0]; // Remove milliseconds and Z if present
      const timeForInput = timeOnly.length > 5 ? timeOnly.substring(0, 5) : timeOnly; // Get HH:MM format
      
      return `${datePart}T${timeForInput}`;
    } else if (dateString.includes(' ')) {
      const [datePart, timePart] = dateString.split(' ');
      const timeForInput = timePart.length > 5 ? timePart.substring(0, 5) : timePart; // Get HH:MM format
      
      return `${datePart}T${timeForInput}`;
    } else {
      return dateString;
    }
  };


  const addSailingCurrencyData = async (e) => {
    e.preventDefault();
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let hasError = false;

    if (!currency.trim()) {
      setCurrencyError("Currency Code is required");
      hasError = true;
    } else {
      setCurrencyError("");
    }

    if (!vesselId) {
      setVesselError("Vessel is required");
      hasError = true;
    } else {
      setVesselError("");
    }

    if (!startDate) {
      setStartDateError("Effective Start is required");
      hasError = true;
    } else {
      setStartDateError("");
    }

    if (!endDate) {
      setEndDateError("Effective End is required");
      hasError = true;
    } else if (startDate && new Date(endDate) <= new Date(startDate)) {
      setEndDateError("End date must be after start date");
      hasError = true;
    } else {
      setEndDateError("");
    }

    if (hasError) {
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      return;
    }

    let dataValues = {
      currency,
      vessel_id: vesselId,
      is_active: isActive ? 1 : 0,
      from_date: startDate,
      to_date: endDate,
    };

    const values = {
      ...dataValues,
    };

    let data;
    if (venus?.id) {
      data = await updateSailingCurrency(venus?.id, {
        ...values,
      });
    } else {
      data = await createSailingCurrency(values);
    }
    if (data?.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
      return;
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
    if (venus?.id) {
      addlog(
        LOG_ACTIONS.UPDATED,
        LOG_TYPES.Currency,
        {
          id: venus.id,
          title: `${dataValues.currency} currency , ${vesselOptions.find(v => v.id === dataValues.vessel_id)?.name} Vessel`,
        },
        userDetails.id
      );
    } else {
      addlog(
        LOG_ACTIONS.CREATED,
        LOG_TYPES.Currency,
        {
          id: data.id,
          title: `${data.currency} currency , ${vesselOptions.find(v => v.id === data.vessel_id)?.name} Vessel`,
        },
        userDetails.id
      );
    }
    if (!venus?.id) {
      navigate("/shore/mobile-masters/sailing_currency");
    } else {
      navigate("/shore/mobile-masters/sailing_currency");
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: "Values updated", type: "success" },
      });
    }
  };

  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    let activity = await getCategoryOption({ limit: 1000 });
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      let vesselData = vessels.filter((item) =>
        checkPermission(
          permission,
          "read_per",
          "Categories",
          window?.location?.pathname +
          `/${item.name.toLowerCase().replaceAll(" ", "-")}`
        )
      );
      setVesselOptions(vesselData);
      setDeckOptions(activity?.data);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addSailingCurrencyData}>
              <div className="card-body">
                <div className="row">
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Currency Code  <span style={{ color: "red" }}>*</span>{" "}</label>
                      <input
                        value={currency}
                        onChange={(e) => {
                          setCurrency(e.target.value);
                          setCurrencyError("");
                        }}
                        className="f_input"
                        type="text"
                        style={{
                          border: currencyError ? "1px solid red" : "1px solid #ccc",
                        }}
                      />
                      {currencyError && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {currencyError}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Vessels <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <Select
                        variant="outlined"
                        error={!!vesselError}
                        sx={{
                          width: "100%",
                          height: "45px",
                        }}
                        value={vesselId}
                        onChange={(e) => {
                          setVesselId(e.target.value);
                          setVesselError("");
                        }}
                      >
                        {vesselOptions.map((item, index) => (
                          <MenuItem key={index + ""} value={item?.id}>
                            <div
                              dangerouslySetInnerHTML={{ __html: item.name }}
                            ></div>
                          </MenuItem>
                        ))}
                      </Select>
                      {vesselError && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {vesselError}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Enter Effective Start  <span style={{ color: "red" }}>*</span>{" "}</label>
                      <input
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                          setStartDateError("");
                        }}
                        step="1"
                        className="f_input"
                        type="datetime-local"
                        style={{
                          border: startDateError ? "1px solid red" : "1px solid #ccc",
                        }}
                      />
                      {startDateError && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {startDateError}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Enter Effective End  <span style={{ color: "red" }}>*</span>{" "}</label>
                      <input
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                          setEndDateError("");
                        }}
                        step="1"
                        className="f_input"
                        type="datetime-local"
                        style={{
                          border: endDateError ? "1px solid red" : "1px solid #ccc",
                        }}
                      />
                      {endDateError && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {endDateError}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* 
                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"

                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {venus?.id ? "Update" : "Add"} Currency
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default ShipCurrencyInput;
